import { DocumentoExpress } from "./SubMenus/DocumentoExpress";

export const DocumentosExpress = [DocumentoExpress];
